import React from "react";

import ReportFeature from "../features/admin/report";

function Report(props) {
  return <ReportFeature {...props} />;
}

export default Report;
